<template>
<main class="clients" :class="loaded ? 'loaded' : loaded">
  <template v-if="clients && Object.keys(clients).length">
    <section class="padded page-header">
      <p class="catch-line" v-html="clients[currentLang].mainTitle"></p>
      <p class="desc" v-html="setDescription(clients[currentLang].description)"></p>
    </section>
    <scroll-view>
      <template slot-scope="visibility">
        <component :is="component" v-for="component in clientsComponents"
          :currentLang="currentLang"
          :displayLogo="true"
          :key="component" 
          :clients="clients" 
          :isLandingMounted="isLanding"
          :visible="visibility[component]" 
          :site="site"/>
      </template>
    </scroll-view>
  </template>
</main>
</template>

<script>

  const ClientsList = () => import( /* webpackChunkName: "ClientsList" */ '@/modules/ClientsList.vue');
  //const Testimonials = () => import( /* webpackChunkName: "Testimonials" */ '@/modules/Testimonials.vue');
  const ContactFooter = () => import( /* webpackChunkName: "ContactFooter" */ '@/snippets/ContactFooter.vue');

import { $scrollview } from 'vue-scrollview'
import { mapState } from 'vuex'
import loaderHandler  from '@/mixins/loaderHandler.js'

  export default {
    props:['currentLang'],
    name: 'Clients',
    components: {
      ClientsList,
      ContactFooter
    },
    mixins: [loaderHandler],
    metaInfo() {
      return {
        title: this.clients.title,
         meta: [
          { name: 'description', content: null, },
          {
            property: 'og:description',
            content: null,
          },
          {
            property: 'og:url',
            content: this.site.url+this.$route.fullPath,
          },
        ]
      }
    },
    data(){
      return {
        updateNav: true,
        clientsComponents: ['ClientsList', 'ContactFooter'],
        scroll: $scrollview,
        isLanding: true
      }
    },
    computed: mapState(['site', 'clients']),
    methods: {
      emitToApp(){
        this.$emit('mountedPage', {isBgLight : true});
      },
      setDescription(desc){
        this.$metaInfo.meta[0].description = this.$metaInfo.meta[1].description = desc;
        return desc;
      }
    },
    created() {
      this.$store.dispatch('loadClients');
    },
    mounted(){
      this.emitToApp();
      this.displayComponent(200);
    },
  }
</script>

<style lang="scss">
  main{
     min-height: 100vh;
     .page-header{
        opacity:0;
        @include transform(translate(0,10%));
        @include transition(opacity .5s ease, transform .3s ease);
     }
     &.loaded{
        .page-header{
          opacity:1;
          @include transform(translate(0,0));
        }
    }
    .desc{
      font-size: 1.7333333em;
      line-height: 1.5;
      letter-spacing: 0.16px;
      max-width:900px
    }
  }

  #app .clients .page-header{
    padding-bottom: 5.66667em!important;
    &:after{
      display:none;
    }
  }
 
</style>
